export default __webpack_public_path__ + "static/media/grid.d4616d8c.svg";